import React from 'react';
import './TourPage.css';

import { PageTitle, Heading, Tour, PagesNo, EmptyState, ShowcaseHeader } from '../../../components';
import { useFilterLoading, useTourFilter } from '../../../utils';

import { FaHiking } from 'react-icons/fa';



const TourPage = () => {  

  // Fetch filtered and paginated tour data using the custom hook `useTourFilter`
    const {
      searchKeyword,      // Current search keyword
      matchingTours,      // List of tours matching the search and filters
      sortOption,         // Current sorting option
      handleSort,         // Function to handle sorting changes
      currentPage,        // Current page number
      displayedTours,     // Function to handle search form submission
      totalPages,         // Total number of pages
      handlePageChange,   // Function to handle page change in pagination
    } = useTourFilter();

    // Use the custom hook `useFilterLoading` to determine if filtering is in progress
    const isFiltering = useFilterLoading(matchingTours, searchKeyword);

  return (  
    <div className='tours-page'> 

      {/* Page title */}
      <PageTitle title={'Tours'} page={'Tours'} />

      <section className='tours'>

        {/* Tours section */}
        <div className='tours-container'>

          {/* Check if there are matching tours */}
          {isFiltering ? null : matchingTours.length === 0 ? (
            <EmptyState
              icon={FaHiking} 
              title="No Tours Found" 
              message="We couldn’t find any tours matching your search." 
              buttonLink="Tours" 
              buttonText="Explore All Tours" 
            />
          ) : (
            <>

              {/* Section heading */}
              <Heading title={'Our Tours'} subTitle={'Explore Our Adventure Tours'} />

              {/* Tour header component */}
              <ShowcaseHeader
                showing={displayedTours.length}
                total={matchingTours.length}
                sortOption={sortOption}
                handleSort={handleSort}
                isTour={true}
              />

              {/* Tours Container */}
              <div className='box-container'>
                {/* Render each Tour component */}
                {displayedTours.map((tour) => {
                  return(  
                    <Tour key={tour.id} tour={tour} />
                  )
                })
                }
              </div>

              {/* pagination component */}
              <PagesNo currentPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChange} />

            </>
            )}
        </div>

      </section>

    </div>
  );
}

export default TourPage;